module.exports = __webpack_public_path__ + "img/left-arrow.c7378884.svg";